import { render } from "./DisclaimerPage.vue?vue&type=template&id=19e1da03&scoped=true"
import script from "./DisclaimerPage.vue?vue&type=script&lang=js"
export * from "./DisclaimerPage.vue?vue&type=script&lang=js"

import "./DisclaimerPage.vue?vue&type=style&index=0&id=19e1da03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e1da03"]])

export default __exports__